import React from "react";
import Box from "@mui/material/Box";

export default function Gears() {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        width: 160,
        height: 160,
        opacity: 0.18,
        pointerEvents: "none",
        zIndex: 0,
      }}
    >
      <Box
        component="svg"
        viewBox="0 0 120 120"
        sx={{ width: "100%", height: "100%" }}
      >
        {/* Outer gear */}
        <Box
          component="g"
          sx={{
            transformOrigin: "40px 40px",
            animation: "gear-outer-spin 9s linear infinite",
            "@keyframes gear-outer-spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          <circle
            cx="40"
            cy="40"
            r="20"
            fill="none"
            stroke="rgba(0,0,0,0.9)"
            strokeWidth="3"
          />
          <circle
            cx="40"
            cy="40"
            r="8"
            fill="none"
            stroke="rgba(0,0,0,0.9)"
            strokeWidth="2"
          />
          {Array.from({ length: 8 }).map((_, i) => {
            const angle = (i * 45 * Math.PI) / 180;
            const x1 = 40 + Math.cos(angle) * 20;
            const y1 = 40 + Math.sin(angle) * 20;
            const x2 = 40 + Math.cos(angle) * 26;
            const y2 = 40 + Math.sin(angle) * 26;
            return (
              <line
                key={`outer-tooth-${i}`}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke="rgba(0,0,0,0.9)"
                strokeWidth="3"
                strokeLinecap="round"
              />
            );
          })}
        </Box>

        {/* Inner gear */}
        <Box
          component="g"
          sx={{
            transformOrigin: "85px 75px",
            animation: "gear-inner-spin 12s linear infinite",
            "@keyframes gear-inner-spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(-360deg)" },
            },
          }}
        >
          <circle
            cx="85"
            cy="75"
            r="14"
            fill="none"
            stroke="rgba(0,0,0,0.8)"
            strokeWidth="3"
          />
          <circle
            cx="85"
            cy="75"
            r="5"
            fill="none"
            stroke="rgba(0,0,0,0.8)"
            strokeWidth="2"
          />
          {Array.from({ length: 6 }).map((_, i) => {
            const angle = (i * 60 * Math.PI) / 180;
            const x1 = 85 + Math.cos(angle) * 14;
            const y1 = 75 + Math.sin(angle) * 14;
            const x2 = 85 + Math.cos(angle) * 20;
            const y2 = 75 + Math.sin(angle) * 20;
            return (
              <line
                key={`inner-tooth-${i}`}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke="rgba(0,0,0,0.9)"
                strokeWidth="3"
                strokeLinecap="round"
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

